import { render, staticRenderFns } from "./BatchStartups.vue?vue&type=template&id=7faaca86&scoped=true"
import script from "./BatchStartups.vue?vue&type=script&lang=js"
export * from "./BatchStartups.vue?vue&type=script&lang=js"
import style0 from "./BatchStartups.vue?vue&type=style&index=0&id=7faaca86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faaca86",
  null
  
)

export default component.exports